import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { TokenCounter } from './TokenCounter';
import { BuyTokensModal } from './BuyTokensModal';
import { toast } from '../../../shared/hooks/useToast';

export const WalletHeader = () => {
    const [totalTokens, setTotalTokens] = useState(1250000); // Mock initial state
    const [isBuyModalOpen, setIsBuyModalOpen] = useState(false);

    const handlePurchase = (amount: number) => {
        // Trigger animation by updating state
        setTotalTokens(prev => prev + amount);
        // Audit C-02: feedback explícito de éxito tras la recarga.
        toast.success(`Acreditamos ${amount.toLocaleString('es-AR')} créditos a tu plan`);
        setTimeout(() => setIsBuyModalOpen(false), 800); // Close after animation start
    };

    return (
        <div className="flex flex-col md:flex-row md:justify-between md:items-end gap-4 mb-4">
            <div>
                <h1 className="text-4xl font-bold text-gray-900 tracking-tight">Plan y créditos</h1>
                <p className="text-gray-500 mt-1">Movimientos y crédito disponible de tu plan</p>
            </div>

            <div className="flex items-center gap-6">
                <TokenCounter totalTokens={totalTokens} />

                <Button
                    onClick={() => setIsBuyModalOpen(true)}
                    className="h-10 px-6 rounded-xl font-semibold shadow-lg shadow-violet-200 bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 text-white border-none transition-all hover:scale-105"
                >
                    Recargar créditos
                </Button>
            </div>

            <BuyTokensModal
                isOpen={isBuyModalOpen}
                onClose={() => setIsBuyModalOpen(false)}
                onPurchase={handlePurchase}
            />
        </div>
    );
};
